<template>
    <div class="-mt-14 relative">
        <img class="object-cover absolute h-full top-0 left-0 w-full" src="/img/header.jpg"/>
        <div class="container relative mx-auto py-4 md:py-36 px-4">
            <div class="w-full mdcd:w-1/2 ">
                <div class="bg-white p-10">
                    <h1 class="text-2xl mb-2">Herzlich willkommen beim Online-Heizkostenvergleich des BDEW</h1>
                    <div class="text-sm">
                        Der BDEW-Heizkostenvergleich gibt Bauherren, Architekten und Planern einen Überblick über die aktuelle Kostensituation bei verschiedenen Systemen zur Heizung und Warmwasserbereitung.
                    </div>
                    <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mt-4" role="alert">
                        <strong class="font-bold">
                          Es wird darauf hingewiesen, dass aktuell Energiepreise und Herstellkosten einer deutlichen Preisdynamik unterliegen. Die hinterlegten Preise und Kosten aus dem Jahr 2022 sollten individuell geprüft und ggf. angepasst werden.
                        </strong>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container mx-auto px-2 py-10">
        <div class="flex -mx-4 flex-wrap">
            <div class="w-full md:w-1/2 px-4">
                Auf Basis des BDEW-Heizkostenvergleiches berechnet dieses Online-Tool die jährlichen Heizkosten für alle üblichen Energieträger und Heiztechnologien und ermittelt auch, wie viel Treibhausgas die neue Anlage einspart. Die Webanwendung ermöglicht die Anpassung von Daten.
            </div>
            <div class="w-full md:w-1/2 px-4">
                Nach Eingabe Ihres Benutzernamens (Ihre E-Mail-Adresse) und ihres Passwortes können Sie dann den Heizkostenvergleich nutzen, zum Beispiel auch um einem Ihrer Kunden zu zeigen, mit welchen Energiekosten er – auf Basis dieser Beispielrechnung – etwa bei einem Wechsel des Energieträgers für die Beheizung seiner Immobilie rechnen kann.
            </div>
        </div>
    </div>
    <div v-if="!loggedIn" class="relative">
        <div class="hidden md:block absolute w-1/2 h-full left-0 top-0 bg-primary-default"></div>
        <div class="container mx-auto px-2 mt-0 md:pt-10 pb-0 md:pb-10 relative">
            <div class="flex -mx-4 flex-wrap">
                <div class="w-full md:w-1/2 px-4 bg-primary-default">
                    <Login :is-home="true" class="hidden md:block w-10/12"/>
                    <Login :is-home="true" :form-input-prefix="'login-mobile'" class="block md:hidden w-full py-8"/>
                </div>
                <div class="w-full md:w-1/2 px-4">
                    <div class="md:pl-8 pt-6 md:pt-0">
                        <h2>Registrieren</h2>
                        <h3>Um den Online-Heizkostenvergleich nutzen zu können, bedarf es einer kostenfreien Registrierung.</h3>
                        <div>Als registrierter Nutzer stehen Ihnen die Funktionen des Online-Heizkostenvergleichs des BDEW zur Verfügung.</div>
                        <div class="mt-8">
                            <base-button :router-link="true" link="register" button-class="invert">Kostenlos registrieren</base-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="relative">

        <img src="/img/stock_01.jpg" class="hidden md:block object-cover absolute w-1/2 h-full right-0 top-0 bg-primary-default"/>

        <div class="container mx-auto px-2 py-10 relative">
            <div class="flex -mx-4 flex-wrap pb-0 md:pb-12">
                <div class="w-full md:w-1/2 px-4">
                    <h2>Haben Sie noch Fragen? </h2>
                    <h3>Sollten Sie Fragen zum Online-Heizkostenvergleich haben, können Sie sich gern an Herrn Täschner wenden</h3>
                    <div class="mt-8">
                        <base-button :router-link="true" link="contact" button-class="invert">Kontakt aufnehmen</base-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import {computed} from "vue";
import {useStore} from "vuex";

export default {
    setup() {
        const store = useStore();
        const loggedIn = computed(() => store.getters['Customer/isLoggedIn']);

        return {
            loggedIn
        }
    }
}
</script>
